

$(document).on('click', '.cart__remove', function(){
  $(this).parent(".custom.cart__item--qty").find(".js-qty__num").val(1);
  $(this).parent(".custom.cart__item--qty").find(".js-qty__adjust--minus").trigger("click");
})



$(document).ready(function(){
  setTimeout(function() {
  if ($(".webyzeProductColors").length > 0) {
    $(".variant-wrapper.js").css('display','none');
  
  }
    else{
        $(".variant-wrapper.js").css('display','block');
    }
      }, 1000);
})

 
$(document).on('change','select[name="id"]', function(e){
    on_variant_change();
});
on_variant_change();
function on_variant_change(){
var current_variant = $('select[name="id"]').val();
$('.stock-msg').hide();
$('.id-'+current_variant).show();
}





$(function(){
  $('#stickyAtc button').click(function(e) {
    e.preventDefault();
    var top = $('.product-single__form').offset().top - 70;
    $('html, body').animate({ scrollTop: top}, 500, 'linear');
  });

  if (window.matchMedia('(max-width: 767px)').matches) {
    var stickyBtn = $('#stickyAtc');

    $(window).scroll(function(){
      var anyIsInViewport = false;
      var ctaBtns = $('.product-single__form, [data-dynamic-variants-enabled], [data-product-images]');
      ctaBtns.each(function(){
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          anyIsInViewport = true;
        }
      });

      if (anyIsInViewport) {
        stickyBtn.addClass('hide');
      } else {
        stickyBtn.removeClass('hide');
      }
    });
  }
});


$(function(){
  $('.upsell-atc').click(function(e) {
    e.preventDefault();
    var variantId = $(this).closest('.drawer__upsell-atc-form').find('.upcell-variant-select').val();
    let formData = {
     'items': [{
      'id': variantId,
      'quantity': 1
      }]
    };
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: JSON.stringify(formData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      // if (data.status === 422) {
      //   console.log('error: ', data);
      // } else {
      //   console.log('success: ', data);
      // }
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    });
  });
});





